
// Section with Editor
$(document).on('shopify:section:load', function(e){ 
  $('#' + e.target.id).find('[data-section]').sectionJs();
}).ready(function() {
  $('[data-section]').each(function(){ $(this).sectionJs() });
});


$.fn.sectionJs = function(){
  var $this = this;
  if($this.data('section') == "NivoSlider") {
    $this.find('.slider-active').NivoSliderActive();
  }else if($this.data('section') == "VideoSlider") {
    $this.VideoSlider();
  }else if($this.data('section') == "HeaderSection") {
    $this.HeaderSection();
  }else if($this.data('section') == "FeaturedProduct") {
    $this.FeaturedProduct();
  }else if($this.data('section') == "AboutTemplate") {
    $this.AboutTemplate();
  }else if($this.data('section') == "Counter") {
    $this.Counter();
  }else if($this.data('section') == "ProductTemplate") {
    $this.ProductTemplate();
  }else{}   
}

// Nivo Slider active js
$.fn.NivoSliderActive = function() {
  var $NivoSliderCarousel = this;
  $NivoSliderCarousel.owlCarousel({
    loop: true,
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
    items: 1,
    dots: false,
    nav: true,
    navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 1
      },
      1000: {
        items: 1
      }
    }
  });
};

// Video Slider active js
$.fn.VideoSlider = function() {
  if($(window).width() > 767){
    $('.youtube-bg').YTPlayer({
      containment: '.youtube-bg',
      autoPlay: true,
      loop: true,
    });
  }
};

// Header active js
$.fn.HeaderSection = function() {
  /*-------------------------
      main-menu active
    --------------------------*/
    $('.main-menu nav').meanmenu({
      meanScreenWidth: "991",
      meanMenuContainer: '.mobile-menu'
    });

    /*-------------------------
      search active
    --------------------------*/
    $(".icon-search").on("click", function() {
      $(this).parent().find('.toogle-content').slideToggle('medium');
    });
    
    /*--
     Menu Sticky
    -----------------------------------*/
    var windows = $(window);
    var stickey = $(".style-6");

    windows.on('scroll', function() {
      var scroll = windows.scrollTop();
      if (scroll < 1) {
        stickey.removeClass("stick");
      } else {
        stickey.addClass("stick");
      }
    });
};

// Featured product active js
$.fn.FeaturedProduct = function() {
  $('.grid.grid-masonry').imagesLoaded( function() {

    // init Isotope
    var $grid = $('.grid.grid-masonry').isotope({
      itemSelector: '.grid-item',
      percentPosition: true,
      masonry: {
        // use outer width of grid-sizer for columnWidth
        columnWidth: '.grid-item',
      }
    });
  });
};

// About Template active js
$.fn.AboutTemplate = function() {
  /*-------------------------
      testimonial-active
    --------------------------*/

  $('.testimonial-active').owlCarousel({
    loop: true,
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
    items: 1,
    dots: false,
    nav: false,
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 1
      },
      1000: {
        items: 1
      }
    }
  });
};

// About Template active js
$.fn.Counter = function() {
  
  /* counterUp */
  $('.count').counterUp({
    delay: 10,
    time: 1000
  });


};

// Product Template active js
$.fn.ProductTemplate = function() {
  /*-------------------------
      product thumb img slider
    --------------------------*/
  $('.pro-thumb-img-slider').owlCarousel({
    loop: true,
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
    items: 5,
    dots: false,
    margin: 25,
    nav: true,
    navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
    responsive: {
      0: {
        items: 3
      },
      600: {
        items: 3
      },
      1000: {
        items: 5
      }
    }
  });
};



(function($) {
  "use strict";

  jQuery(document).ready(function(){


    /*--- showlogin toggle function ----*/

    $( '#showlogin' ).on('click', function() {
      $( '#checkout-login' ).slideToggle(900);
    }); 

    /*--- showlogin toggle function ----*/
    $( '#showcoupon' ).on('click', function() {
      $( '#checkout_coupon' ).slideToggle(900);
    });

    /*--- showlogin toggle function ----*/
    $('#ship-box').on('click', function() {
      $('#ship-box-info').slideToggle(1000);
    });




    

    /*-------------------------------------------
        03. scrollUp jquery active
    --------------------------------------------- */
    $.scrollUp({
      scrollText: '<i class="fa fa-angle-up"></i>',
      easingType: 'linear',
      scrollSpeed: 900,
      animation: 'fade'
    });


    




    /*-- Product Quantity --*/
    $('.product-quantity2').append('<span class="dec qtybtn"><i class="fa fa-angle-left"></i></span><span class="inc qtybtn"><i class="fa fa-angle-right"></i></span>');
    $('.qtybtn').on('click', function() {
      var $button = $(this);
      var oldValue = $button.parent().find('input').val();
      if ($button.hasClass('inc')) {
        var newVal = parseFloat(oldValue) + 1;
      } else {
        // Don't allow decrementing below zero
        if (oldValue > 0) {
          var newVal = parseFloat(oldValue) - 1;
        } else {
          newVal = 0;
        }
      }
      $button.parent().find('input').val(newVal);
    });


    /* Match Heigh */ 
    
    $(function() {
      $('.featured-product-grid').matchHeight();
    });  
    
    $(function() {
      $('.shop-grid-view').matchHeight();
    }); 
    
    $(function() {
      $('.blog-grid-view').matchHeight();
    });
    
    $(function() {
      $('.match-height-active').matchHeight();
    });
    
    /* Mega Menu */
   $('.mega-menu-li').parent('ul').addClass('mega-menu');
   
   $('.icon-search > a').removeAttr('href');
    
   /* preloader */
    $(window).on('load', function() {
      $('#preloader_active').fadeOut('slow');
    }); 
    
    
    
    /*--------------------------	
	shop page manu dropdown	
	---------------------------- */	
    $('.dropdown .option-btn').on('click', function(){
      if($(this).siblings('.dropdown-menu').hasClass('active')){
        $(this).siblings('.dropdown-menu').removeClass('active').slideUp();
        $(this).removeClass('active');
      }
      else{
        $('.dropdown .dropdown-menu').removeClass('active').slideUp();
        $('.dropdown .option-btn').removeClass('active');
        $(this).addClass('active');
        $(this).siblings('.dropdown-menu').addClass('active').slideDown();
      }
    });
    

    $('[data-countdown]').each(function() {
      var $this = $(this), finalDate = $(this).data('countdown');
      $this.countdown(finalDate, function(event) {
        $this.html(event.strftime('<div class="countdown-area"><div class="single-countdown"><div class="count-number">%D</div><div class="count-title">days</div></div><div class="single-countdown"><div class="count-number">%H</div><div class="count-title">Hour</div></div><div class="single-countdown"><div class="count-number">%M</div><div class="count-title">Mint</div></div><div class="single-countdown"><div class="count-number">%S</div><div class="count-title">Sec</div></div></div>'));
      });
    });

  });

})(jQuery);



